import './header.scss';
import './menu/menu';
import { createRoot } from 'react-dom/client';
import { Menu } from '@/eden/theme/sections/header/menu/menu';

const selector = document.getElementById('root-header-menu');
if (selector) {
  const root = createRoot(selector);
  root.render(<Menu />);
}
